module.exports = __webpack_public_path__ + "static/media/20_A.db94c8b2.png";